<template>
  <div class="product-reviews-slider" v-if="comments.length">
    <div class="product-reviews-slider__title">
      <h3 class="reviews-slider__title title--second">
        {{ $t('product-reviews__reviews') }}
        <span class="reviews-slider__total" v-if="total">
          {{ total }}
        </span>
        <AddCommentButton
          class="product-reviews-slider__add-review"
          type="pseudo-link"
          :post-comment-endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
          :form-type="$constants.COMMENTS.FORM_TYPE_PRODUCT"
          :product-id="productId"
        />
      </h3>
      <div class="product-slider__navigation">
        <div class="swiper-button-prev reviews__swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next reviews__swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <div v-if="isDesktop">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="swiper-item" v-for="comment in comments" :key="comment.comment_id">
          <CommentItem
            :is-short="true"
            :comment="comment"
            :endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
            :product-id="productId"
            :is-questions="false"
            :catalogPage="true"
            :is-disabled-actions="true"
          />
        </swiper-slide>
      </swiper>
    </div>
    <div v-else>
      <CommentItem
        v-for="comment in comments.slice(0, 3)"
        :key="comment.comment_id"
        :is-short="true"
        :comment="comment"
        :endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
        :product-id="productId"
        :is-questions="false"
        :is-disabled-actions="true"
      />
    </div>
    <div class="all-link" @click="openTab()">{{ $t('product-reviews__all-reviews') }} →</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommentItem from '@/components/comments/CommentItem.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import AddCommentButton from '@/components/comments/AddCommentButton.vue'

export default {
  name: 'ProductReviewsSlider',
  data () {
    return {
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 2,
        navigation: {
          nextEl: '.reviews__swiper-button-next',
          prevEl: '.reviews__swiper-button-prev'
        },
        autoHeight: true
      }
    }
  },
  components: { AddCommentButton, CommentItem, Swiper, SwiperSlide },
  props: {
    isDesktop: {
      type: Boolean
    },
    openTab: {
      type: Function
    }
  },
  computed: {
    ...mapState({
      comments: state => state.comments.comments.comments,
      total: state => state.comments.comments.total_count,
      productId: state => state.productInfo.productInfo.productId
    })
  }
}
</script>
<style lang="sass" scoped>
@import "../../styles/swiper/swiper"
.all-link
  display: inline-block
  font-size: 16px
  line-height: 24px
  color: #3E77AA
  margin-top: 20px
  cursor: pointer
  &:hover
    text-decoration: underline
.product-reviews-slider
  width: 100%
  padding: 30px 0 0
  &__add-review
    display: block
    font-size: 16px
    line-height: 24px
    color: #3E77AA
    cursor: pointer
    margin-left: auto
    font-weight: 400
    +mmin($tablet)
      margin-left: 45px
  &__title
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 30px
.product-slider__navigation
  position: relative
  width: 65px
  margin-bottom: -10px
  display: none
  +mmin($tablet)
    display: flex

.product-reviews-slider__slider
  display: flex
  justify-content: space-between

.reviews-slider
  margin-bottom: 30px
  &__total
    color: #909090
    margin-left: 10px
    display: inline-block

.swiper-item
  border: 1px solid #f3f3f3
  height: auto
  padding: 25px 30px 10px 30px

  &:not(:last-child)
    border-right: 0

.reviews-slider__title
  padding: 0
  margin: 0
  display: flex
  align-items: center
  flex-grow: 1

.swiper
  margin-top: 20px
</style>
<style lang="sass">
.product-reviews-slider
  .product-comments-card--short
    padding-bottom: 10px
  .product-comments-card__comment
    overflow: hidden
    text-overflow: ellipsis
    max-height: 105px
    -webkit-line-clamp: 5
    display: -webkit-box
    -webkit-box-orient: vertical
  .product-comments-item
    height: auto
    list-style: none
    margin-bottom: 10px
    +mmin($tablet)
      border: none
  .swiper-wrapper
    box-sizing: border-box
.product-reviews-slider .swiper-container-autoheight .swiper-wrapper
  align-items: stretch
</style>
